import { format } from "date-fns";

import { Botao, Cores, Corpo, Icone, Modal, Titulo } from "@componentes-mu/componentes-mu";

import styles from "./styles.module.scss";
import { RespostaCanalDireto } from "../../../types/atendimentos/channel-direct/types";
import { FlexColumn, FlexRow } from "../../../components/Flex";
import { Ticket } from "../../../types/tickets/types";

type ModalDirectChannelProps = {
    isOpen: boolean;
    onClose: () => void;
    respostaCanalDireto: RespostaCanalDireto
    ticket: Ticket
}



export const ModalDirectChannel = ({ isOpen, onClose, respostaCanalDireto, ticket }: ModalDirectChannelProps) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
        >
            <div className={styles.modalContent}>
                <FlexColumn gap="2rem" justifyContent="center" alignItems="center">

                    <FlexRow justifyContent="space-between">
                        <Titulo tipo="cabecalho2" negrito >Resposta de Canal Direto - {ticket.ticket}</Titulo>
                        <Botao onClick={onClose} cor={Cores.MensagensDoSistema.VermelhoADMU}>
                            <Icone nome={"close"} cor="#FDFDFD" />
                        </Botao>
                    </FlexRow>


                    <FlexColumn gap="1rem" justifyContent="center" alignItems="center">

                        <FlexRow justifyContent='flex-start' gap={"1rem"}>
                            <Corpo tipo="body1" cor={Cores.GradacaoNeutros.CinzaFillMU600} negrito={700}>Data da resposta:</Corpo>
                            <span>{format(new Date(respostaCanalDireto.dataResposta), 'dd/MM/yyyy')}</span>
                        </FlexRow>

                        <FlexRow justifyContent='flex-start' gap={"1rem"}>
                            <Corpo tipo="body1" cor={Cores.GradacaoNeutros.CinzaFillMU600} negrito={700}>Respondido por:</Corpo>
                            <span>{respostaCanalDireto.respondidoPor}</span>
                        </FlexRow>

                        <FlexRow justifyContent='flex-start' gap={"1rem"}>
                            <Corpo tipo="body1" cor={Cores.GradacaoNeutros.CinzaFillMU600} negrito={700}>Resposta:</Corpo>
                            <span>{respostaCanalDireto.resposta}</span>
                        </FlexRow>

                    </FlexColumn>
                </FlexColumn>
            </div>

        </Modal>
    )
}